// @ts-nocheck
/* eslint-disable */
export const messageDownArrowIcon = {
  data: `<svg fill="currentColor" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 476.492 476.492" xml:space="preserve"><polygon points="253.246,339.952 253.246,0 223.246,0 223.246,339.952 101.707,339.952 238.246,476.492 374.785,339.952"/></svg>`,
  name: 'message-down-arrow' as const,
};
